module.exports = __webpack_public_path__ + "img/Engagement_Highly_Engaged_32.14af116f.png";